'use strict';

function initRatingsUI($container) {
    $container.each(function () {
        // get the average rating
        var $inlineRatingsUI = $(this).find('.rating-stars');
        if ($inlineRatingsUI.length && !$inlineRatingsUI.hasClass('js-ratings-initialized')) {
            var averageRating = $inlineRatingsUI.data('star-average').toString();
            // break apart the remainder
            var ratingParts = averageRating.split('.'),
                fullStars = parseInt(ratingParts[0], 10),
                partialStar = parseInt(ratingParts[1], 10);
            $inlineRatingsUI.find('.rating-star').each(function (index) {
                if (fullStars >= index + 1) {
                    $(this).attr('class', 'rating-star full-star');
                } else if (fullStars + 1 === index + 1 && partialStar > 0) {
                    $(this).attr('class', 'rating-star partial-star');
                    var partFill = 'linear-gradient(to right, rgb(240,213,32) ' + (partialStar*10) + '%, rgb(242,242,242) ' + (partialStar*10) + '%)';
                    $(this).css('background', partFill);
                } else {
                    $(this).attr('class', 'rating-star empty-star');
                }
            });
            $inlineRatingsUI.addClass('js-ratings-initialized');
        }
    });
}

function observeReviewsOnPDP() {
    var parentNode = document.getElementById('js-container');

    if (!parentNode) {
        return;
    }

    var reviewsLoaded = false;

    new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (addedNode) {
                if (addedNode && addedNode.classList && addedNode.classList.contains('bv-cleanslate')) {
                    reviewsLoaded = true;
                    $(document).trigger('pdp.reviews.loaded', $(addedNode));
                }
            });

            if (!reviewsLoaded && mutation.addedNodes.length === 0) {
                $(document).trigger('pdp.reviews.empty');
            }
        });
    }).observe(parentNode, {
        subtree: true,
        childList: true
    });
}

module.exports = {
    init: function () {
        var $productTiles = $('.product-tile');
        initRatingsUI($productTiles);
        observeReviewsOnPDP();
    },
    applyEvents: function () {
        $('body').on('ratingsAndReviews:init', function () {
            initRatingsUI($('.product-review'));
        });

        $('body').on('quickview:ready', function (e, data) {
            initRatingsUI(data.$quickViewModal);

            window.bvCallback = function () {
                data.$quickViewModal.find('#data-bv-show').css('display', 'block');
            };
        });

        $(document).on('search:showMoreUpdated', function () {
            initRatingsUI($('.product-review'));
        });

        $('body').on('search:filterUpdated', function () {
            initRatingsUI($('.product-review'));
        });
    }
};
